<template>
  <div>
    <div class="order-home">
      <van-sticky>
        <div class="brand-card">
          <!-- 左边logo + 右边双行文字 -->
          <div class="brand-header">

              <!-- 左侧 LOGO 图片 -->
              <div class="logo-wrapper">
                  <!-- 实际使用时，将 src 替换为您的 logo 图片地址 -->
                  <img :src="logo" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
                  <!-- 如果图片加载失败，显示占位 (兼容) -->
                  <div class="logo-placeholder" style="display:none;">LOGO</div>
              </div>

              <!-- 右侧文字：公司名称 + 产品名称 两行 -->
              <div class="brand-text">
                  <span class="company-name">深圳市绘视医疗科技有限公司</span>
                  <span class="product-name">3D可视化分析服务</span>
              </div>

          </div>
        </div>
        <!-- <div style="padding-top:16px;padding-bottom:16px;background-color:#FFF;">
          <div class="order-home__title"><img :src="logo"><span>3D可视化分析服务</span></div>
        </div> -->
      </van-sticky>
      <div>
      <van-skeleton :loading="loading" :row="10" style="margin:30px 2px;">
        <van-tabs v-model="statusActive"  sticky offset-top="96" swipeable @click="onSelectTab" >
          <van-tab v-for="item in statusTabs" :key="item.value" :title="item.title" :name="item.value" :style="orderList.length == 0 ? '' : 'background-color: #f4f4f4;'" >
            <van-empty v-if="orderList.length == 0" description="还没有任何相关订单" />
            <div v-else  v-for="item in orderList" :key="item.id">
              <div class='prod-item'>
                <div class="order-num">
                  <span>{{item.createTime}}</span>
                  <div class='order-state'>
                    <van-tag plain :type="statusTags[item.status]" size="medium" >{{statusNames[item.status]}}</van-tag>
                  </div>
                </div>
                <div class='item-cont'>
                  <div class='prod-info'>
                    <div class='prodname'>
                      单号：{{item.orderNo}}
                    </div>
                    <div class='prodname'>
                      患者：{{item.patient}} {{item.medicalRecord}}
                    </div>
                    <div class='prodname'>
                      城市：{{item.proName}} {{item.cityName}}
                    </div>
                    <div class='prodname'>
                      医院：{{item.hosName}} {{item.depName}} 
                    </div>
                  </div>
                </div>
                <div class='total-num'>
                  <div class='prodprice'>金额：
                    <span class='symbol'>￥</span>
                    <span class='big-font'>{{parsePrice(item.amount)[0]}}</span>
                    <span class='small-font'>.{{parsePrice(item.amount)[1]}}</span>
                  </div>
                </div>
                <div class='prod-foot'>
                  <div class='btn'>
                    <van-button v-if="item.status==0" @click="cancelOrder(item.id)" type="danger" round size="small" style="width:80px;">取消订单</van-button>                    
                    <van-button v-if="item.status==0"  @click="payOrder(item.id, item.amount)" type="primary" round size="small" style="width:80px;margin-left:5px;">去付款</van-button>
                    <van-button v-if="item.invoiceImage" @click="toViewInvoice(item.id)" type="primary" round size="small" style="width:80px;margin-left:5px;">查看发票</van-button>
                    <van-button v-if="item.analysisResult" @click="toViewAnalysis(item.id)" type="primary" round size="small" style="width:80px;margin-left:5px;">查看分析</van-button>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </van-skeleton>
      </div>
    </div>
    <Payment ref="payment" v-model="showPayment" @success="paymentCallback" />
    <Statement ref="statement" v-model="showStatement" @confirm="statementConfirm" />
  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, Tag, Tab, Tabs, Empty, Sticky, Button, Skeleton, Toast, Dialog } from 'vant';
import logo from '@/assets/logo/logo.png'
import Payment from '@/components/payment'
import Statement from '@/components/statement'
import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Empty.name]: Empty,
    [Sticky.name]: Sticky,
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    Payment,
    Statement
  },
  data() {
    return {
      logo,
      loading: false,
      showPayment: false,
      showStatement: false,
      statusActive: -1,
      statusTabs: [{
        title: "全部",
        value: -1
      },{
        title: "未付款",
        value: 0
      },{
        title: "已付款",
        value: 1
      },{
        title: "已完成",
        value: 3
      }],
      statusNames: {'-1': "全部",'0' : "未付款",'1' : "已付款",'2': "已取消",'3' : "已完成",'4' : "已退款"},
      statusTags: {'0' : "danger",'1' : "warning",'2' : "primary",'3' : "success", '4' : "danger"},
      orderList: [],
      orderId: undefined,
      amount: undefined
    }
  },
  // mounted(){
  //   this._loadData()
  // },
  created(){
    this._loadData()
  },
  methods: {
    onSelectTab(){
      this._loadData()
    },
    _loadData(){
      this.loading = true
      let params = {}
      if(this.statusActive != -1){
        params.status = this.statusActive
      }
      request({
        url: '/wxpubapis/order',
        method: 'get',
        params: params
      }).then(({data}) => {
        // for(let i = 0 ; i < 5 ; i++){
        // data.forEach(element => {
        //   this.orderList.push(element)
        // });
        // }
        this.orderList = data
        this.loading = false
      });
    },
    statementConfirm(){
      this.showPayment = true
      this.$nextTick(() => {
        this.$refs.payment.show(this.orderId, this.amount)
      })
    },
    payOrder(orderId, amount){
      this.orderId = orderId
      this.amount = amount
      this.showStatement = true
      this.$nextTick(() => {
        this.$refs.statement.open()
      })
    },
    paymentCallback() {
      this._loadData()
    },
    cancelOrder(orderId){
      Dialog.confirm({
        title: '取消订单',
        message: '您确定要取消订单吗？',
      }).then(() => {
        this._cancelOrder(orderId)
      }).catch(() => {
        // on cancel
      });
      
    },
    _cancelOrder(orderId){
      Toast.loading({
        message: '处理中',
        forbidClick: true,
        overlay: true,
        duration: 0
      })
      request({
        // url: this.orderId ? `/wxpubapis/apply/order/${this.orderId}` : '/wxpubapis/apply/order',
        // method: this.orderId ? 'put' : 'post',
        url: `/wxpubapis/order/cancel/${orderId}`,
        method: 'put'
      }).then(() => {
        Toast.success()
        this._loadData()
      }).catch(() => Toast.clear())
    },
    toViewInvoice(orderId){
      let token = getToken()
      // location.href = 'http://localhost:8080'+ process.env.VUE_APP_BASE_API +'/wxpubapis/invoice/image/' + token + '/' + orderId
      // location.href = 'https://wxpub.huishimedical.com.cn'+ process.env.VUE_APP_BASE_API +'/wxpubapis/invoice/image/' + token + '/' + orderId
      // let pdfUrl = encodeURIComponent(process.env.VUE_APP_BASE_API +'/wxpubapis/invoice/image/' + token + '/' + orderId)
      // window.open('/#/pdf?pdfUrl=' + pdfUrl)
      this.$router.push({path: '/pdf' , query: {pdfUrl: process.env.VUE_APP_BASE_API + '/wxpubapis/invoice/image/' + token + '/' + orderId}})
    },
    toViewAnalysis(orderId){
      let token = getToken()
      // location.href = 'http://localhost:8080'+ process.env.VUE_APP_BASE_API +'/wxpubapis/order/analysis/' + token + '/' + orderId
      // location.href = 'https://wxpub.huishimedical.com.cn'+ process.env.VUE_APP_BASE_API +'/wxpubapis/order/analysis/' + token + '/' + orderId
      
      this.$router.push({path: '/pdf' , query: {pdfUrl: process.env.VUE_APP_BASE_API + '/wxpubapis/order/analysis/' + token + '/' + orderId}})
    },
    parsePrice(val){
      if (!val) {
        val = 0;
      }
      if(typeof(val) == 'string'){
        val = Number(val)
      }
      return val.toFixed(2).split(".");
    }
  }
};
</script>

<style lang="less">
.main {
  margin-top: 50px;
}

/* 商品列表 */

.prod-item {
  background-color: #fff;
  margin-top: 7px;
  font-size: 14px;
}

.prod-item .order-num {
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.order-state {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.prod-item .item-cont {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 5px;
  display: -webkit-flex;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  background: #fafafa;
}

.prod-item .item-cont .prod-info {
  margin-left: 5px;
  font-size: 14px;
  width: 100%;
  position: relative;
  height: 80px;
  -webkit-flex: 1;
  -ms-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  flex: 1;
}

.prod-item .item-cont .prod-info .prodname {
  font-size: 14px;
  line-height: 18px;
  max-height: 43px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-all;
  margin-bottom: 5px;
}

.prod-item  .total-num {
  text-align: right;
  padding: 10px 15px;
  font-size: 14px;
}

.prod-item .total-num .prodprice {
  display: inline-block;
  color: #333;
  margin-left: 10rpx
}

.prod-item  .prod-foot {
  padding: 10px 15px;
  border-top: 1px solid #e6e6e6;
}

.prod-item  .prod-foot .btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.order-home {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  // padding: 46px 0px 0px;
  background: #fff;
  // background-color: #f4f4f4;
  
  &__title {
      // margin: 0 0 16px;
      font-size: 18px;

      img {
        width: 64px;
      }

      img, span {
        display: inline-block;
        vertical-align: middle;
      }
  }
  &__desc {
    margin: 0;
    color: rgba(69, 90, 100, 0.6);
    font-size: 14px;
  }

  &__title, &__desc {
    padding-left: 16px;
    font-weight: normal;
    line-height: 1;
    -webkit-user-select: none;
    user-select: none;
  }
}
</style>
